module.exports = __webpack_public_path__ + "static/img/mv.3c896bfd.svg";